export enum BulkActions {
  INSTALL = 'INSTALL',
  UNINSTALL = 'UNINSTALL',
  UPDATE = 'UPDATE',
  EVENT = 'EVENT',
}
